import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { GroupEvent } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { startupsUrl } from '@src/lib/startups-url.ts';
import moment from 'moment';
import { EventJsonLd, EventJsonLdProps } from 'next-seo';
export const GroupEventSEO = props => {
  const $ = _c(36);
  let eventData;
  let isOfficeHours;
  let t0;
  if ($[0] !== props.groupEvent.description || $[1] !== props.groupEvent.endsAt || $[2] !== props.groupEvent.hosts || $[3] !== props.groupEvent.startsAt || $[4] !== props.groupEvent.title || $[5] !== props.groupEvent.type?.title || $[6] !== props.groupEvent.typeKey) {
    const seoProps = {};
    isOfficeHours = props.groupEvent.typeKey === "office-hours";
    let t1;
    if ($[10] !== props.groupEvent.endsAt || $[11] !== props.groupEvent.startsAt || $[12] !== props.groupEvent.title) {
      t1 = {
        endDate: props.groupEvent.endsAt,
        location: "Online",
        name: props.groupEvent.title,
        startDate: props.groupEvent.startsAt
      };
      $[10] = props.groupEvent.endsAt;
      $[11] = props.groupEvent.startsAt;
      $[12] = props.groupEvent.title;
      $[13] = t1;
    } else {
      t1 = $[13];
    }
    eventData = t1;
    if (isOfficeHours) {
      const t2 = props.groupEvent.title;
      let t3;
      if ($[14] !== props.groupEvent.hosts) {
        t3 = props.groupEvent.hosts.map(_temp).join(" and ");
        $[14] = props.groupEvent.hosts;
        $[15] = t3;
      } else {
        t3 = $[15];
      }
      seoProps.title = `Office Hours: ${t2} with ${t3}`;
    } else {
      const t2 = props.groupEvent.title;
      let t3;
      if ($[16] !== props.groupEvent.hosts) {
        t3 = props.groupEvent.hosts.map(_temp2).join(" and ");
        $[16] = props.groupEvent.hosts;
        $[17] = t3;
      } else {
        t3 = $[17];
      }
      let t4;
      if ($[18] !== props.groupEvent.startsAt) {
        t4 = moment(props.groupEvent.startsAt).format("ll");
        $[18] = props.groupEvent.startsAt;
        $[19] = t4;
      } else {
        t4 = $[19];
      }
      seoProps.title = `Event: ${t2} with ${t3} on ${t4}`;
    }
    seoProps.description = props.groupEvent.description;
    const t2 = props.groupEvent.type?.title;
    const t3 = props.groupEvent.title;
    let t4;
    if ($[20] !== props.groupEvent.hosts[0]?.firstName || $[21] !== props.groupEvent.hosts[0]?.lastName || $[22] !== props.groupEvent.hosts[0]?.pictureUrl || $[23] !== props.groupEvent.startsAt || $[24] !== props.groupEvent.title || $[25] !== t2) {
      const t5 = props.groupEvent.hosts[0]?.firstName;
      const t6 = props.groupEvent.hosts[0]?.lastName;
      let t7;
      if ($[27] !== t5 || $[28] !== t6) {
        t7 = [t5, t6].filter(Boolean);
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
      } else {
        t7 = $[29];
      }
      t4 = startupsUrl("/api/og-image", {
        badge: t2,
        title: t3,
        tagline: props.groupEvent.startsAt ? moment(props.groupEvent.startsAt).format("dddd MMM Do, YYYY - hh:mm a") : undefined,
        authorBadge: "With",
        author: t7.join(" "),
        avatar: props.groupEvent.hosts[0]?.pictureUrl
      });
      $[20] = props.groupEvent.hosts[0]?.firstName;
      $[21] = props.groupEvent.hosts[0]?.lastName;
      $[22] = props.groupEvent.hosts[0]?.pictureUrl;
      $[23] = props.groupEvent.startsAt;
      $[24] = props.groupEvent.title;
      $[25] = t2;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    seoProps.imageUrl = t4;
    t0 = <SEOMetadata {...seoProps} />;
    $[0] = props.groupEvent.description;
    $[1] = props.groupEvent.endsAt;
    $[2] = props.groupEvent.hosts;
    $[3] = props.groupEvent.startsAt;
    $[4] = props.groupEvent.title;
    $[5] = props.groupEvent.type?.title;
    $[6] = props.groupEvent.typeKey;
    $[7] = eventData;
    $[8] = isOfficeHours;
    $[9] = t0;
  } else {
    eventData = $[7];
    isOfficeHours = $[8];
    t0 = $[9];
  }
  let t1;
  if ($[30] !== eventData || $[31] !== isOfficeHours) {
    t1 = !isOfficeHours && <EventJsonLd {...eventData} />;
    $[30] = eventData;
    $[31] = isOfficeHours;
    $[32] = t1;
  } else {
    t1 = $[32];
  }
  let t2;
  if ($[33] !== t0 || $[34] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[33] = t0;
    $[34] = t1;
    $[35] = t2;
  } else {
    t2 = $[35];
  }
  return t2;
};
GroupEventSEO.fragments = {
  GroupEvent: () => gql`
    fragment _ on GroupEvent {
      id
    }
  `
};
function _temp(h) {
  return [h.firstName, h.lastName].filter(Boolean).join(" ");
}
function _temp2(h_0) {
  return [h_0.firstName, h_0.lastName].filter(Boolean).join(" ");
}